/**
 * 대시보드 지도 모듈 singleclick 계획.
 * 리스트가 닫혀 있어도 모듈을 누르면 리스트를 열고 해당 행으로 포커스한다.
 * 결함 모달(연필)은 열지 않는다.
 */
export function planModuleSingleClick({ resolvedModule, moduleListOpen }) {
  if (!resolvedModule) {
    return {
      openList: false,
      applyFocus: false,
      clearSelection: !!moduleListOpen
    };
  }
  return {
    openList: !moduleListOpen,
    applyFocus: true,
    clearSelection: false
  };
}
